<template>
  <nav class="navbar navbar-expand-md navbar-dark bg-colorful fixed-top">
    <div class="container-fluid">
      <a class="navbar-brand" href="/">{{ brand_name }}</a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse">
        <ul class="navbar-nav mr-auto ml-5 mt-2 mt-lg-0" v-if="isAdmin || isPrinter ">
          <li class="nav-item"><router-link to="/orders?status=not_finished&ordering=downloaded_at" class="nav-link" active-class="active"><i class="fa fa-shopping-cart"></i> 订单</router-link></li>
          <li class="nav-item"><router-link to="/tasks" class="nav-link" active-class="active"><i class="fa fa-tasks"></i> 打印任务</router-link></li>
          <li class="nav-item"><router-link to="/operation" class="nav-link"  active-class="active"><i class="fa fa-send"></i> 发货</router-link></li>
          <li class="nav-item" style="position: relative;"><router-link to="/aftersales" class="nav-link"  active-class="active"><i class="fa fa-warning"></i> 售后</router-link><b-img style="position: absolute;top: 6px;right: -5px;" rounded="circle" blank width="6" height="6" blank-color="#dc3545" alt="img" class="m-1" /></li>
        </ul>
        
        <ul class="navbar-nav ml-auto mr-5 mt-2 mt-lg-0" v-if="isAdmin || isPrinter" style="text-aligh:right;">
          <li class="nav-item" style="float:right"><router-link to="/report" class="nav-link" active-class="active"><i class="fa fa-line-chart"></i>  统计</router-link></li>
          <li class="nav-item"><router-link to="/main_products" class="nav-link" active-class="active"><i class="fa fa-book"></i> 产品</router-link></li>
          <li class="nav-item"><router-link to="/companies" class="nav-link" active-class="active"><i class="fa fa-trademark"></i> 公司</router-link></li>
          <li class="nav-item"><router-link to="/order_loggers" class="nav-link"  active-class="active"><i class="fa fa-list"></i> 日志</router-link></li>
          <li class="nav-item"><router-link to="/materials" class="nav-link"  active-class="active"><i class="fa fa-truck"></i> 物料</router-link></li>
          <li class="nav-item"><router-link to="/help" class="nav-link"  active-class="active"><i class="fa fa-question-circle-o"></i> 帮助</router-link></li>
        </ul>

        <ul class="navbar-nav mr-auto mt-2 mt-lg-0" v-else>
          <li class="nav-item"><router-link to="/orders?status=not_finished" class="nav-link" active-class="active"><i class="fa fa-shopping-cart"></i> 订单</router-link></li>
          <li class="nav-item"><router-link to="/main_products" class="nav-link" active-class="active"><i class="fa fa-book"></i> 产品</router-link></li>
          <li class="nav-item" style="position: relative;"><router-link to="/aftersales" class="nav-link"  active-class="active"><i class="fa fa-warning"></i> 售后</router-link><b-img style="position: absolute;top: 6px;right: -5px;" rounded="circle" blank width="6" height="6" blank-color="#dc3545" alt="img" class="m-1" /></li>
          <li class="nav-item"><router-link to="/companies" class="nav-link" active-class="active"><i class="fa fa-trademark"></i> 公司</router-link></li>
          <li class="nav-item"><router-link to="/help" class="nav-link"  active-class="active"><i class="fa fa-question-circle-o"></i> 帮助</router-link></li>
        </ul>
      </div>

      <a class="navbar-text" style='white-space: nowrap' href="#" v-if="user && user.nickname" v-on:click.prievent="goToLogin">欢迎您，{{user.nickname}}</a>
    </div>
  </nav> 
</template>

<script>
// import Icon from 'vue-awesome/components/Icon'
import {getHostName} from '@/utils/tools'
import RoleMixin from '@/mixins/role'

function goToLogin () {
  this.$router.push({
    path: 'login'
  })
}

export default {
  name: 'navbar',
  data () {
    return {
      brand_name: '订单生产管理-' + getHostName().toUpperCase()
    }
  },
  mixins: [RoleMixin],
  methods: {
    goToLogin
  }
}
</script>